import { useMemo } from "react";
import useTranslation from "../../../shared/hooks/useTranslation";

export interface SettingsNavSection {
  key: string;
  labelKey: string;
  path: string;
  iconName: string;
  visible: boolean;
}

const useSettingsNav = (): { sections: SettingsNavSection[] } => {
  const { translate } = useTranslation("settings");

  // Future: const isProvider = customer?.roleCode === RoleCode.supplier;
  // For now, show pricing and service to everyone — the backend will decide
  // In production, gate on: const { isProvider, isHybrid } = useCompanyType();

  const allSections: SettingsNavSection[] = useMemo(
    () => [
      {
        key: "profile",
        labelKey: "settings:nav.profile",
        path: "profile",
        iconName: "PersonOutlined",
        visible: true,
      },
      {
        key: "company",
        labelKey: "settings:nav.company",
        path: "company",
        iconName: "BusinessOutlined",
        visible: true,
      },
      {
        key: "locations",
        labelKey: "settings:nav.locations",
        path: "locations",
        iconName: "PlaceOutlined",
        visible: true,
      },
      {
        key: "notifications",
        labelKey: "settings:nav.notifications",
        path: "notifications",
        iconName: "NotificationsOutlined",
        visible: true,
      },
      {
        key: "team",
        labelKey: "settings:nav.usersAndAccess",
        path: "team",
        iconName: "PeopleOutlined",
        visible: true,
      },
      {
        key: "pricing",
        labelKey: "settings:nav.pricing",
        path: "pricing",
        iconName: "PaymentsOutlined",
        visible: true, // Future: isProvider || isHybrid
      },
      {
        key: "service",
        labelKey: "settings:nav.service",
        path: "service",
        iconName: "BuildOutlined",
        visible: true, // Future: isProvider || isHybrid
      },
      {
        key: "shipping",
        labelKey: "settings:nav.shipping",
        path: "shipping",
        iconName: "LocalShippingOutlined",
        visible: true, // Future: hasInventory
      },
      {
        key: "appearance",
        labelKey: "settings:nav.appearance",
        path: "appearance",
        iconName: "PaletteOutlined",
        visible: true,
      },
    ],
    []
  );

  const sections = useMemo(
    () => allSections.filter((s) => s.visible),
    [allSections]
  );

  return { sections };
};

export default useSettingsNav;
